import React from 'react';
import ReactDOM from 'react-dom';
import RecruiterToolsBelt from '../../src/recruiter_tools_belt/recruiter_tools_belt';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('recruiterToolsBelt');

  if (root) {
    ReactDOM.render(
      <DevexHighOrderComponent>
        <RecruiterToolsBelt
          id={JSON.parse(root.dataset.id)}
          name={JSON.parse(root.dataset.name)}
          notes={JSON.parse(root.dataset.notes)}
          manageCuratedLists={JSON.parse(root.dataset.manageCuratedLists)}
          curatedCandidateLists={JSON.parse(root.dataset.curatedCandidateLists)}
        />
      </DevexHighOrderComponent>,
      root
    );
  }
});
